/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {EditAttributesOutlined, FlagOutlined, LinkOutlined, TitleOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ESTADOANUNCIOS} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";


const Formulario_Adicionales = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOANUNCIOS.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imagen del servicio dimencion 2x3 (peso menor a 300Kb) esto es opcional</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={2} ancho={3}
                                       dato={'img'} {...props}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre de la pagina'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={8} nombre={'Descripcion primer parrafo'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={EditAttributesOutlined} nombre={'Texto del boton'}
                                  dato={'botonTexto'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={LinkOutlined} nombre={'Link de boton'}
                                  dato={'link'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Adicionales